export const buildProvenance = { "commitHash": "6365df3daed0992e54bcc31b70230110faa0f9d6", "branchName": "refs/heads/release/2023.4", "buildDate": "2024-02-16T12:50:40.846Z", "version": "2023.4.8338" };
